module.exports = __webpack_public_path__ + "img/image01_sp.a88f4cd7.jpg";